import { Modal, Button } from "react-bootstrap";
import useTenant from "../tenant/useTenant";
type TParams = {
  show: boolean;
  onClose: any;
  onSuccess: any;
  message: string[];
}
const ModalAlert = (props: TParams) => {
  const { show, onClose, onSuccess, message } = props
  const tenant = useTenant();

  return (
    <Modal show={show} onHide={onClose}>
      <Modal.Header closeButton>
        <Modal.Title>{tenant.brandName}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {message.map((text, index) => < ><span key={index}>{text}</span>< br /></>)}
      </Modal.Body>
      <Modal.Footer>
        <Button
          variant="success"
          onClick={onSuccess}
        >
          Aceptar
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ModalAlert;
